var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass:
        "bg-white z-20 fixed w-full shadow-xl py-2 sm:py-4 xl:py-8 px-2"
    },
    [
      _c(
        "div",
        { staticClass: "flex relative" },
        [
          _c("header-burger"),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "hidden h-16 xs:flex items-center absolute right-0 top-0 mr-2 sm:mr-4"
            },
            [
              _c(
                "a",
                {
                  staticClass:
                    "bg-brand-gray-dark hover:bg-brand-gray-mid2 uppercase text-white font-sans-bold font-semibold text-base tracking-tight py-3 px-5 rounded block w-full sm:w-auto inline-flex items-center justify-between",
                  attrs: { href: "/contact-us" }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "fill-current w-4 h-4 sm:mr-3",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 20 20"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M18 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h16zm-4.37 9.1L20 16v-2l-5.12-3.9L20 6V4l-10 8L0 4v2l5.12 4.1L0 14v2l6.37-4.9L10 14l3.63-2.9z"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "hidden sm:inline-block" }, [
                    _vm._v("Contact us")
                  ])
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "nav",
        [
          _c("header-sidebar", [
            _c(
              "ul",
              { staticClass: "mt-20 sm:mt-24 xl:mt-32" },
              _vm._l(_vm.links, function(link) {
                return _c("li", { key: link.url }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "block px-4 py-3 font-bold text-sm hover:bg-brand-gray-light focus:outline-none focus:underline active:bg-brand-orange-600 active:text-white",
                      class: [
                        _vm.currentLocation == link.url
                          ? "text-white bg-brand-orange-500 hover:bg-brand-orange-500"
                          : "text-brand-gray-dark"
                      ],
                      attrs: { href: link.url }
                    },
                    [_vm._v(_vm._s(link.text))]
                  )
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("ul", { staticClass: "mt-4" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass:
                      "flex items-center px-4 py-3 text-sm hover:text-brand-orange-500 focus:outline-none focus:underline active:bg-brand-orange-600 active:text-white",
                    attrs: { href: "mailto:info@onemilegrid.com.au" }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "fill-current w-4 h-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 20 20"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M18 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h16zm-4.37 9.1L20 16v-2l-5.12-3.9L20 6V4l-10 8L0 4v2l5.12 4.1L0 14v2l6.37-4.9L10 14l3.63-2.9z"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("info@onemilegrid.com.au")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass:
                      "flex items-center px-4 py-3 text-sm hover:text-brand-orange-500 focus:outline-none focus:underline active:bg-brand-orange-600 active:text-white",
                    attrs: { href: "tel:0399398250" }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "fill-current w-4 h-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 20 20"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M20 18.35V19a1 1 0 0 1-1 1h-2A17 17 0 0 1 0 3V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4c0 .56-.31 1.31-.7 1.7L3.16 8.84c1.52 3.6 4.4 6.48 8 8l2.12-2.12c.4-.4 1.15-.71 1.7-.71H19a1 1 0 0 1 .99 1v3.35z"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("(03) 9939 8250")])
                  ]
                )
              ])
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "flex-auto h-16 xl:h20 flex items-center 2xl:max-w-screen-xl 2xl:mx-auto"
      },
      [
        _c(
          "a",
          {
            staticClass: "inline-block align-middle 2xl:-ml-24",
            attrs: { href: "/" }
          },
          [
            _c("img", {
              staticClass: "h-12 ml-3 sm:h-16 xl:h-20 xl:ml-6 2xl:ml-0",
              attrs: {
                src: "/dist/img/onemilegrid-logo.png",
                alt: "onemilegrid"
              }
            })
          ]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }